export const httpParamKey = {
    domainAUserGuid: 'domainAUserGuid',
    domainAUserNr: 'domainAUserNr',
    projectAMemberGuid: 'projectAMemberGuid',
    projectAMemberNr: 'projectAMemberNr',
    value: 'value',
    key: 'key',
} as const;

export type HttpParamKey = typeof httpParamKey[keyof typeof httpParamKey];
